import script from "./ComHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComHeader.vue?vue&type=script&setup=true&lang=ts"

import "./ComHeader.vue?vue&type=style&index=0&id=42ebddeb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ebddeb"]])

export default __exports__